module.exports = __webpack_public_path__ + "static/media/whatua.cb30b711.svg";